import { scheduleDeferred } from './scheduleDeferred.js';
import { applyConsent, readStoredConsent } from '../Shared/utils/cookieConsent.js';

// GA4 is configured inside GTM (container GTM-W2VTTCGV, tag G-938X92VHPV).
// The container loads only after a stored analytics or advertising choice.
export function initAnalyticsDeferred() {
    scheduleDeferred(() => {
        const stored = readStoredConsent();
        if (!stored) {
            return;
        }

        applyConsent(stored);
    });
}

export function pushAnalyticsEvent(event, params = {}) {
    if (typeof window === 'undefined' || !event) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
}
